'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import DrawerMenu from './DrawerMenu.react';
import { useMealOperations } from '../contexts';

/**
 * SkipMenu - Functional component for Plans/Editor
 * Uses DrawerMenu for consistent UI with Dashboard
 */
const SkipMenu = ({ meals, primary }) => {
    const { removeMeals, startReplaceMeal } = useMealOperations();

    const handleSkipMeal = (closeModal) => {
        removeMeals(meals.map(meal => meal.uuid || meal.id));
        closeModal();
    };

    const handleEatOut = (closeModal) => {
        startReplaceMeal(primary.offset, primary.meal, meals, { defaultMode: 'restaurants' });
        closeModal();
    };

    const handleFavorites = (closeModal) => {
        startReplaceMeal(primary.offset, primary.meal, meals, { defaultMode: 'favorites' });
        closeModal();
    };

    const handleSearch = (closeModal) => {
        startReplaceMeal(primary.offset, primary.meal, meals, { defaultMode: 'browser' });
        closeModal();
    };

    return (
        <DrawerMenu
            button={<span>clear</span>}
            className="skip-menu-btn"
            modalClassName="feed-skip-menu"
            menuTitle="Try These Options"
        >
            {({ closeModal }) => (
                <div className="feed-menu-content">
                    <button
                        className="menu-item eat-out-instead"
                        onClick={() => handleEatOut(closeModal)}
                    >
                        Eat out instead <i className="icon-location-pin" />
                    </button>
                    <button
                        className="menu-item favorites"
                        onClick={() => handleFavorites(closeModal)}
                    >
                        Choose from favorites <i className="icon-heart2" />
                    </button>
                    <button
                        className="menu-item search"
                        onClick={() => handleSearch(closeModal)}
                    >
                        Search Foods and Recipes <i className="icon-search5" />
                    </button>
                    <button
                        className="skip-meal-btn"
                        onClick={() => handleSkipMeal(closeModal)}
                    >
                        No thanks, clear meal
                    </button>
                </div>
            )}
        </DrawerMenu>
    );
};

SkipMenu.propTypes = {
    meals: PropTypes.array.isRequired,
    primary: PropTypes.object,
};

export default SkipMenu;
